import React from 'react';
import NoValue from '../../EmptyStates/NoValue';
import parsePhoneNumber from 'libphonenumber-js'

const PhoneNumber = ({phoneNumber, countryCode = 'GB', link = true}) => {
    if (!phoneNumber) {
        return <NoValue />;
    }

    const numberInstance = parsePhoneNumber(phoneNumber, countryCode);
    let display = phoneNumber;

    if (numberInstance) {
        display = numberInstance.formatNational();
    }

    if (!link) {
        return display;
    }

    return <a href={`tel:${phoneNumber}`} className="link">{display}</a>;
}

export default PhoneNumber;